import React from 'react'
import StudentDetails from '../../pages/LogInPage/StudentDetails';

const AddStudentDetails = () => {
  return (
    <div className="gap-9 flex flex-col items-center p-6 pb-9 bg-satPrepFrostedWhite backdrop-blur-[20px] shadow-dialog border-[0.5px] border-satPrepGrey rounded-[28px]">
      <h1 className="font-gully text-[40px] font-bold text-center text-appPrimaryColor">
        Add student details
      </h1>
      <StudentDetails />
    </div>
  );
}

export default AddStudentDetails
